import React from "react";
import { BarChart3, Eye, ShieldCheck, Users } from "lucide-react";
import SectionHeading from "../SectionHeading/SectionHeading";
import WhyChooseCard from "../WhyChooseCard/WhyChooseCard";

const CARDS = [
  {
    icon: Eye,
    title: "Coach from evidence, not memory",
    description:
      "Replace anecdotal feedback with real conversations. Every recommendation is grounded in what your rep actually said — timestamped, scored, and ready for the next 1:1.",
  },
  {
    icon: BarChart3,
    title: "Spot problems before they cost you",
    description:
      "Discounting creeps in. Discovery shortens. Confidence shifts. FieldCoach surfaces behavior-level patterns early — so you can correct trajectory before it impacts revenue.",
  },
  {
    icon: Users,
    title: "Scale ride-alongs without scaling managers",
    description:
      "One manager can't shadow every call. FieldCoach reviews every conversation continuously — so coaching reaches every rep, every week, without adding headcount or hours.",
  },
];

const WhyChooseBlock: React.FC = () => (
  <section className="relative overflow-hidden bg-[#F6F7FA] py-24 dark:bg-slate-900">
    <div className="mx-auto max-w-7xl px-6">
      <div className="mx-auto mb-16 max-w-3xl text-center">
        <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-primary/15 bg-cream-dark px-4 py-2 text-sm font-bold text-primary dark:bg-primary/15 dark:text-primary-light">
          <ShieldCheck className="h-4 w-4" />
          Built for Home Service Contractors
        </div>
        <SectionHeading>Why Managers Choose FieldCoach</SectionHeading>
        <p className="mx-auto mt-5 max-w-xl text-lg text-gray-500 dark:text-gray-400">
          Everything you need to see, score, and reinforce what&rsquo;s
          happening on every call in the field.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {CARDS.map((card) => (
          <WhyChooseCard
            description={card.description}
            icon={card.icon}
            key={card.title}
            title={card.title}
          />
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseBlock;
